import reducer, { getQuestionFromTags, getMetricsForTags, getQuestionForId, getTagForId } from './reducer';

export default reducer;
export { getQuestionFromTags, getMetricsForTags, getQuestionForId, getTagForId };



// WEBPACK FOOTER //
// ./src/reducers/index.js